import { render, staticRenderFns } from "./TableWithDrawer.vue?vue&type=template&id=475dd523&scoped=true"
import script from "./TableWithDrawer.vue?vue&type=script&lang=js"
export * from "./TableWithDrawer.vue?vue&type=script&lang=js"
import style0 from "./TableWithDrawer.vue?vue&type=style&index=0&id=475dd523&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475dd523",
  null
  
)

export default component.exports